














































import { defineComponent, computed, PropType } from '@vue/composition-api';
import { TrackingPixelOption } from '../types';
import TtamTrackingPixelEcho from '../pixel-echo/index.vue';

const name = 'ttam-tracking-pixel-select';

export default defineComponent({
  name,

  components: { TtamTrackingPixelEcho },

  props: {
    title: { type: String, default: '' },
    rules: { type: Array, default: () => [] },
    titleTip: { type: String, default: '' },
    value: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    options: {
      type: Array as PropType<TrackingPixelOption[]>,
      default: () => [],
    },
  },

  setup(props, ctx) {
    const pixelLabel = computed(() => props.value.toString());

    const _pixel = computed({
      get: () => props.value,
      set: val => {
        ctx.emit('change', val);
        ctx.emit('input', val);
      },
    });

    // const trackingOptions = computed(() => {
    //   const arr: { label: string; options: TrackingPixelOption[] }[] = [];
    //   props.options.forEach(item => {
    //     let curGroup = arr.find(i => i.label === item.groupLabel);

    //     if (curGroup) {
    //       curGroup.options.push(item);
    //     } else {
    //       curGroup = { label: item.groupLabel, options: [item] };
    //       arr.push(curGroup);
    //     }
    //   });
    //   return arr;
    // });

    return {
      name,
      _pixel,
      pixelLabel,
      // trackingOptions,
    };
  },
});
